import React, { useState, useEffect } from 'react'

import './Subscriptions.css';
import history from '../../routes/history';
import Visa from "../../assets/img/Visa.png"
import Mastercard from "../../assets/img/mastercard.png"
import Paytm from "../../assets/img/paytm.png"
import Paypal from "../../assets/img/paypal.png"
import Upi from "../../assets/img/upi.png"
import Amex from "../../assets/img/amex.png"
import Check from "../../assets/img/checkicon.png"
import { Row, Col, Button, AutoComplete, Input, Form, Skeleton } from "antd";
// import AmericanExpress from "../../assets/img/american-express.png"

  
const Subscriptions=()=>{

  return (
    <div className='submain-pagediv'>

<div className='submain-header'>
<div className='submain-premium'>Pick your premium</div>
<div className='submain-lorem'>Talk about your company’s mission, vision, and values.</div>
</div>

<div className='submain-headdiv'>

<img src={Visa} alt="Visaicon" style={{width: '39.1px', height: '12px'}}></img>
<img src={Mastercard} alt="MasterCardicon" style={{width: '20.1px', height: '12px'}}></img>
<img src={Paytm} alt="Paytmicon" style={{width: '37.9px', height: '12px'}}></img>
<img src={Paypal} alt="Paypalicon" style={{width: '12.2px', height: '12px'}}></img>
<img src={Upi} alt="Upiicon" style={{width: '36.8px', height: '12px'}}></img>
<img src={Amex} alt="Amexicon" style={{width: '12px', height: '12px'}}></img>

</div>
<div  className="submain-resp" >

<div className='submain-div' >
    <div className='submain-recom'>
<div className='submain-recom-subhead'>Recommended</div>
<div className='submain-recom-mainhead'>Recommended for enterprise</div>
</div>

<div className='submain-subdiv'>

<div className='submain-subtxt'>Lorem impsum is simply the dummy text of typesetting industry. Lorem impsum is simply the dummy text of typesetting industry</div>
<div className='submain-maintxt'>Plan benefits</div>


<div>
    <Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Can upload gigs - Upto 100 gigs</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Talent market</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>20 team members</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>1000 top rated candidates</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>can upload gigs - Upto 100 gigs</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Talent market</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>20 Team members</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>1000 Top rated candidates</div>
</Row>
</div>

<div >
<div className='submain-maintxt2'>Plan Price</div>
<div className='submain-maintxt2 submain-maintxt2bold'>$1000 / Month</div>
</div>

<Button className='submain-btn' onClick={()=>history.push("/choose-plan")}>
    View plan
</Button>
    </div>
    </div>

    {/* .................................................222222222222222222222222222222222222222222222222222.......................................... */}
    <div className='submain-div' >
    <div className='submain-recom2'>
<div className='submain-recom-subhead'>Recommended</div>
<div className='submain-recom-mainhead'>Plan for SME</div>
</div>

<div className='submain-subdiv'>

<div className='submain-subtxt'>Lorem impsum is simply the dummy text of typesetting industry. Lorem impsum is simply the dummy text of typesetting industry</div>
<div className='submain-maintxt'>Plan benefits</div>


<div>
    <Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Can upload gigs - Upto 100 gigs</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Talent market</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>20 team members</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>1000 top rated candidates</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>can upload gigs - Upto 100 gigs</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Talent market</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>20 team members</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>1000 top rated candidates</div>
</Row>
</div>

<div>
<div className='submain-maintxt2'>Plan price</div>
<div className='submain-maintxt2 submain-maintxt2bold'>$1000 / month</div>
</div>

<Button className='submain-btn' onClick={()=>history.push("/choose-plan")}>
    View plan
</Button>
    </div>
    </div>

    {/* .............................................33333333333333333333333333333333333333333333333333................................................... */}
    <div className='submain-div' >
    <div className='submain-recom'>
<div className='submain-recom-subhead'>Recommended</div>
<div className='submain-recom-mainhead'>Pay as you go</div>
</div>

<div className='submain-subdiv'>

<div className='submain-subtxt'>Lorem impsum is simply the dummy text of typesetting industry. Lorem impsum is simply the dummy text of typesetting industry</div>
<div className='submain-maintxt'>Plan benefits</div>


<div>
    <Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Can upload gigs - Upto 100 gigs</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Talent market</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>20 team members</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>1000 top rated candidates</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>can upload gigs - Upto 100 gigs</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>Talent market</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>20 team members</div>
</Row>
<Row className='submain-desc'>
        <img src={Check} alt="checkicon" style={{width: '14px', height: '14px'}}></img>
<div className='submain-maintxt2'>1000 Top rated candidates</div>
</Row>
</div>

<div>
<div className='submain-maintxt2'>Plan Price</div>
<div className='submain-maintxt2 submain-maintxt2bold'>$1000 / month</div>
</div>

<Button className='submain-btn' onClick={()=>history.push("/choose-plan")}>
    View plan
</Button>
    </div>
    </div>
    </div>

</div>


  )
}
export default Subscriptions;
